const ModuleMeu = {
    state: {
      meu: {
        basic:[1],
        ability:[1,1,1,1,1],
        education:[1],
        studentExperience:[1,1],
        workplace:[1,1],
        trainExperience:[1],
        rewardExperience:[1],
        projectExperience:[1],
        familyNum:[1],
        subjectiveInfo:[1,1],
      },
    },
    mutations: {
      SETMEU: (state, data) => {
        let tmp = state.meu
        
        tmp[data.type][data.index] = data.value;
        state.meu = {
          ...tmp
        }
      },
    },
    actions: {
      setMeu(context, params) {
        context.commit("SETMEU", params);
      },
    },
  };
 
  export default ModuleMeu;
  